import { useState } from "react";
import "./editorialForms.css";

const postTypes = [
  { id: "discussion", name: "Discussão" },
  { id: "poll", name: "Enquete" },
  { id: "event", name: "Evento" },
  { id: "announcement", name: "Anúncio" },
  { id: "question", name: "Pergunta" },
];

export default function CommunityForm({ data, onChange }) {
  const [tagInput, setTagInput] = useState("");
  const [pollOptionInput, setPollOptionInput] = useState("");

  const handleAddTag = () => {
    if (tagInput.trim()) {
      onChange({
        ...data,
        tags: [...(data?.tags || []), tagInput.trim()],
      });
      setTagInput("");
    }
  };

  const handleRemoveTag = (index) => {
    onChange({
      ...data,
      tags: (data?.tags || []).filter((_, i) => i !== index),
    });
  };

  const handleAddPollOption = () => {
    if (pollOptionInput.trim()) {
      const currentPoll = data?.poll || { options: [], allowMultiple: false };
      onChange({
        ...data,
        poll: {
          ...currentPoll,
          options: [
            ...currentPoll.options,
            { text: pollOptionInput.trim(), votes: 0 },
          ],
        },
      });
      setPollOptionInput("");
    }
  };

  const handleRemovePollOption = (index) => {
    const currentPoll = data?.poll || { options: [] };
    onChange({
      ...data,
      poll: {
        ...currentPoll,
        options: currentPoll.options.filter((_, i) => i !== index),
      },
    });
  };

  return (
    <div className="editorial_form community_form">
      <div className="editorial_form_section">
        <label>Tipo de Publicação</label>
        <select
          value={data?.type || "discussion"}
          onChange={(e) => onChange({ ...data, type: e.target.value })}
        >
          {postTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
      </div>

      <div className="editorial_form_section">
        <label>Nome do Grupo/Comunidade</label>
        <input
          type="text"
          placeholder="Ex: Desenvolvedores React Brasil"
          value={data?.groupName || ""}
          onChange={(e) => onChange({ ...data, groupName: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Título <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Título da sua publicação"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Conteúdo</label>
        <textarea
          placeholder="Escreva sua mensagem, pergunta ou anúncio..."
          value={data?.content || ""}
          onChange={(e) => onChange({ ...data, content: e.target.value })}
          maxLength={3000}
          rows={5}
        />
        <span className="editorial_form_counter">
          {(data?.content || "").length}/3000
        </span>
      </div>

      {data?.type === "poll" && (
        <div className="editorial_form_section">
          <label>
            Opções da Enquete
            <button
              type="button"
              className="add_variant_btn"
              onClick={handleAddPollOption}
            >
              + Adicionar
            </button>
          </label>
          <input
            type="text"
            placeholder="Digite uma opção..."
            value={pollOptionInput}
            onChange={(e) => setPollOptionInput(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleAddPollOption()}
          />
          <div className="genre_chips" style={{ marginTop: "8px" }}>
            {(data?.poll?.options || []).map((option, i) => (
              <span
                key={i}
                className="genre_chip selected"
                onClick={() => handleRemovePollOption(i)}
                style={{ cursor: "pointer" }}
              >
                {option.text} ×
              </span>
            ))}
          </div>

          <div
            className="editorial_form_row"
            style={{ marginTop: "12px", alignItems: "center" }}
          >
            <div className="editorial_form_checkbox">
              <input
                type="checkbox"
                id="allowMultiple"
                checked={data?.poll?.allowMultiple || false}
                onChange={(e) =>
                  onChange({
                    ...data,
                    poll: { ...data?.poll, allowMultiple: e.target.checked },
                  })
                }
              />
              <label htmlFor="allowMultiple">Permitir múltiplas escolhas</label>
            </div>

            <div className="editorial_form_section" style={{ marginBottom: 0 }}>
              <label style={{ marginBottom: "4px" }}>Data de Encerramento</label>
              <input
                type="date"
                value={data?.poll?.endDate?.split("T")[0] || ""}
                onChange={(e) =>
                  onChange({
                    ...data,
                    poll: {
                      ...data?.poll,
                      endDate: new Date(e.target.value).toISOString(),
                    },
                  })
                }
              />
            </div>
          </div>
        </div>
      )}

      <div className="editorial_form_section">
        <label>
          Tags
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddTag}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: react, javascript, ajuda..."
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddTag()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.tags || []).map((tag, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveTag(i)}
              style={{ cursor: "pointer" }}
            >
              #{tag} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isPinned"
            checked={data?.isPinned || false}
            onChange={(e) => onChange({ ...data, isPinned: e.target.checked })}
          />
          <label htmlFor="isPinned">Fixar no topo do grupo</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
        <span>
          Engaje sua comunidade com discussões relevantes e enquetes interativas!
        </span>
      </div>
    </div>
  );
}
